<div class="text-icon-box-wrapper">
  <a [href]="link">
    <div class="text-icon-box-container" fxLayout="row" fxLayoutAlign=" center" >
      <div class="icon-container" fxLayout="column" fxLayoutAlign="center center" style="padding-left: 1em">
        <mat-icon [color]="'accent'">{{icon}}</mat-icon>
      </div>
      <div class="details-container" fxLayout="column"  fxLayoutGap=".15em" fxLayout.lt-md="row" fxLayoutGap.lt-md=".5em">
        <span class="text-span" >{{text}}</span>
        <span class="value-span">{{value}}</span>
      </div>
    </div>
  </a>
</div>
